import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from './../services/login.service';
import { ValidationService } from './../services/validation.service';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChildren('inputid') id;
  @ViewChild('pass') pass: any;
  @ViewChild('input') input: ElementRef;
  loginForm: FormGroup;
  checkError: string;
  public idRemember: boolean;
  public username = '';
  public loader: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private LoginServices: LoginService,
    private router: Router,
    private _data: DataService
  ) {
    this.idRemember = false;
  }

  ngOnInit() {
    this._data.clearData();
    // this.id.nativeElement.focus();
    // (<HTMLInputElement>document.getElementById('inputid')).focus();
    this.loginForm = this.formBuilder.group({
      id: [
        '',
        [
          Validators.required,
          Validators.maxLength(10),
          ValidationService.alphanumericValidator
        ]
      ],
      pass: [
        '',
        [
          Validators.required,
          Validators.maxLength(10),
          ValidationService.alphanumericValidator
        ]
      ]
    });
    if (this._data.idRemember) {
      this.idRemember = true;
      this.username = this._data.idRemember;
    }
    this.loginForm.patchValue({ id: this.username });
  }

  ngAfterViewInit() {
    // this.id.nativeElement.focus();
    // this.id.first.nativeElement.focus();

    this.id.first.nativeElement.focus();
  }

  onSubmit(loginGroup: FormGroup) {
    if (loginGroup.valid) {
      this.LoginServices.checkLogin(loginGroup.value).subscribe(
        data => {
          if (data) {
            this._data.token = data.token;
            this._data.loginTypeKbn = data.loginTypeKbn;
            this._data.expirationTime = data.expirationTime;
            this.rememberId();

            this.LoginServices.isAuthenticated();

            this.router.navigate(['home']);
          }
        },
        error => {
          if (error.rsltCode === 'E401') {
            if (error.rsltComment) {
              this.checkError = error.rsltComment;
            } else {
              this.checkError =
                'ユーザーID、もしくはパスワードが一致しません。';
            }
          } else if (error.rsltCode === 'E500') {
            this.checkError = 'システムエラーが発生しました。';
          } else {
            this.checkError = error.rsltComment;
          }
        }
      );
    } else {
      this.loginForm.controls.id.markAsDirty();
      this.loginForm.controls.pass.markAsDirty();
      if (
        this.loginForm.controls.id.valid &&
        !this.loginForm.controls.pass.valid
      ) {
        this.pass.nativeElement.focus();
      } else if (!this.loginForm.controls.id.valid) {
        this.id.first.nativeElement.focus();
      }
    }
    // console.log(loginGroup.value);
  }

  changeFocus() {
    if (this.loginForm.controls.id.valid) {
      this.pass.nativeElement.focus();
    }
  }

  rememberId() {
    if (this.idRemember) {
      this._data.idRemember = this.loginForm.get('id').value;
    } else {
      this._data.idRemember = null;
    }
  }

  setLoader(loader: boolean) {
    this.loader = loader;
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts